"use strict";
/* tslint:disable */
/**
 * File was automatically generated using json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND.
 * Instead, modify the source file /oada/change/v2.schema.json of @oada/formats
 * and run `$ yarn build` to regenerate this file.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = exports.is = exports.$id = void 0;
// Import packed validation function
const v2_validate_js_1 = __importDefault(require("./v2-validate.js"));
/**
 * $id of the source schema
 * @see {@link https://formats.openag.io/oada/change/v2.schema.json}
 */
exports.$id = "https://formats.openag.io/oada/change/v2.schema.json";
/**
 * Returns true if val is a @type V2, false otherwise
 */
function is(val) {
    return v2_validate_js_1.default(val);
}
exports.is = is;
/**
 * Asserts that val is a @type V2
 */
function assert(val) {
    if (!v2_validate_js_1.default(val)) {
        throw {
            errors: v2_validate_js_1.default.errors,
            input: val
        };
    }
}
exports.assert = assert;
//# sourceMappingURL=v2.js.map